import { useCallback, useEffect, useRef, useState } from 'react';
import { goi } from './api';

/**
 * Hỏi lại backend theo nhịp.
 *
 * Đã chốt: **2–3 giây**, không WebSocket. Ở quy mô một cửa hàng với vài máy thì
 * hỏi lại là đủ, và ít thứ phải nuôi hơn hẳn — không có kết nối treo, không phải
 * xử lý nối lại, nginx không cần cấu hình gì thêm.
 */
export const NHIP_MS = 2500;

interface KetQua<T> {
  duLieu: T | null;
  loi: string | null;
  dangTai: boolean;
  /** Gọi sau khi vừa thay đổi gì đó, để không phải chờ hết một nhịp. */
  taiLai: () => void;
}

export function useHoiLai<T>(duong: string | null, nhipMs = NHIP_MS): KetQua<T> {
  const [duLieu, datDuLieu] = useState<T | null>(null);
  const [loi, datLoi] = useState<string | null>(null);
  const [dangTai, datDangTai] = useState(true);

  // Chặn chồng request: mạng cửa hàng chậm thì một nhịp có thể chưa xong đã tới
  // nhịp sau, và các phản hồi về không đúng thứ tự — màn hình nhấp nháy số cũ.
  const dangChay = useRef(false);
  const conSong = useRef(true);

  const tai = useCallback(async () => {
    if (!duong || dangChay.current) return;
    dangChay.current = true;
    try {
      const d = await goi<T>(duong);
      if (!conSong.current) return;
      datDuLieu(d);
      datLoi(null);
    } catch (e) {
      if (!conSong.current) return;
      datLoi(e instanceof Error ? e.message : 'Lỗi không rõ');
    } finally {
      dangChay.current = false;
      if (conSong.current) datDangTai(false);
    }
  }, [duong]);

  useEffect(() => {
    conSong.current = true;
    datDangTai(true);
    void tai();
    const h = setInterval(() => {
      // Tab bị ẩn thì thôi — máy thu ngân thường mở suốt, nhưng điện thoại nhân
      // viên khoá màn hình cả chục phút thì không cần hỏi.
      if (!document.hidden) void tai();
    }, nhipMs);
    return () => {
      conSong.current = false;
      clearInterval(h);
    };
  }, [tai, nhipMs]);

  return { duLieu, loi, dangTai, taiLai: tai };
}
